import React from 'react';
import Swal from "sweetalert2";

//import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';

import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import {
    Input,
    Label, FormFeedback, Col
} from "reactstrap";

export default function SpinnerFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentDisabled, parentProps, isConfiguration, childShouldRerender } = props;
    //const { t } = useTranslation();
    //const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues, setValue, errors } = formManager;

    const [options, setOptions] = React.useState(data.options || []);
    const [currValue, setCurrValue] = React.useState(loadValue());
    const [hideFilter, setHideFilter] = React.useState(null);
    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (parentProps && parentProps.value >= 0) {
            var newValue = parentProps.value ? (currValue || 0) : 0;
            if (newValue === 0 && data.propNameJsType === "array") {
                newValue = [];
            }
            //setCurrValue(newValue);
            setValue(bindPropResult, newValue);
        }
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }
        if ((!data.children || data.children.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);

    React.useEffect(() => {
        if (parentProps && parentProps.value >= 0) {
            var newValue = parentProps.value ? (currValue || 0) : 0;
            if (newValue === 0 && data.propNameJsType === "array") {
                newValue = [];
            }
            setValue(bindPropResult, newValue);
            setShouldRender(!shouldRender);
        }
    }, [parentProps.value]);

    const { ref: refElem, ...restElem } = register(bindPropResult, {
        value: data.defaultValue || ((data.options && data.options.length) ? data.options[0].value : ""),
        valueAsNumber: (data.subType?.indexOf("integer") >= 0 || data.subType?.indexOf("float") >= 0),
        onChange: (e) => {
            var selValue = e.target.value;
            /*if (data.subType === "integer" || data.subType === "float") {
                selValue = parseInt(selValue);
            }*/
            onChange(selValue);
        }
    });

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.refreshFromCache = (value, withRerender, src) => {
        return new Promise((resolve, reject) => {
            if (data.onActionEvents && data.onActionEvents["onRefresh"]) {
                data.onActionEvents["onRefresh"].forEach((args, index) => {
                    modelFctManager.onActionRequired(data.name, args, data, { value: value }).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }
            resolve({ isSuccess: true, result: value });
        });
    };
    data.functionManager.setValue = (value, withRerender, src) => {
        return new Promise((resolve, reject) => {
            if (value?.startsWith && value.startsWith("{") && value.indexOf("tag") >= 0) {
                var keyItem = JSON.parse(value);
                value = keyItem.value;
            }
            setValue(bindPropResult, value);
            setCurrValue(value);
            if (withRerender) setShouldRender(!shouldRender);

            resolve({ isSuccess: true, result: value });
        });
    };
    data.functionManager.getValue = (src) => {
        //return currValue;
        return currValue || loadValue();
    };
    data.functionManager.getSelectedOption = (src) => {
        if (options) {
            var optionsFilter = options.filter((option) => option.value == (src || currValue || loadValue()));
            //console.debug(optionsFilter);
            if (optionsFilter.length) {
                return optionsFilter[0];
            }
        }
        return null;
    };
    data.functionManager.getSrcData = (src) => {
        if (options) {
            var optionsFilter = options.filter((option) => option.value == (src || currValue || loadValue()));
            //console.debug(optionsFilter);
            if (optionsFilter.length) {
                return optionsFilter[0].srcData;
            }
            else if (Array.isArray(currValue) && data.format === "object") {
                var filterObj = currValue.filter(opt => opt[data.argumentsObj?.loadIdTarget] == src);
                if (filterObj.length) {
                    return filterObj[0];
                }
            }
        }
        return null;
    };
    data.functionManager.triggerChange = (alternativeValue) => {
        return new Promise((resolve, reject) => {
            onChange(alternativeValue || currValue);

            resolve({ isSuccess: true, result: (alternativeValue || currValue) });
        });
    };
    data.functionManager.populateData = populateData;
    data.functionManager.hideOption = (key, operatorTest, value) => {
        if (key) setHideFilter({ key, operatorTest, value });
        else setHideFilter(null);
    };

    var disabled = (isConfiguration ? true : ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false)));

    function onChange(value, newOptions) {
        //console.debug("onChange");
        setCurrValue(value);

        var localOptions = ((newOptions && newOptions.length) ? newOptions : options);
        var srcData;
        if (options) {
            var optionsFilter = localOptions.filter((option) => option.value == value);
            if (optionsFilter.length) {
                srcData = optionsFilter[0].srcData;
            }
        }

        if (data.onActionEvents && data.onActionEvents["onChange"]) {
            data.onActionEvents["onChange"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, { value: value, srcData: srcData, withRerender: true }).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }
    }

    function populateData(dataOptions, triggerOnChange) {
        return new Promise((resolve, reject) => {
            //console.debug("spinnerFrag populateOptions " + bindPropResult);
            //data.options = dataOptions;
            var defaultOptions = data.options ? data.options.filter((opt) => opt.subType === "default") : [];
            if (dataOptions && dataOptions.length) {
                var newOptions = [...defaultOptions, ...dataOptions];
                setOptions(newOptions);

                //Vérification de la présence de la valeur actuelle dans la nouvelle liste (si non, va chercher defaultValue OU option.selected)
                var selectValue = parseInt(currValue) ? parseInt(currValue) : currValue;
                var newValue = selectValue;
                //if (!data.subType?.startsWith("multiple") || data.format === "object") {
                    var foundedOption = dataOptions.filter((elem) => elem.value === selectValue && elem.value != -1);
                    newValue = loadValue(newOptions, foundedOption.length ? selectValue : null);
                    //console.debug(newValue);
                    if (triggerOnChange) onChange(newValue, newOptions);
                    else setCurrValue(newValue);
                    if (parentProps && parentProps.value >= 0) {
                        newValue = parentProps.value ? newValue : 0;
                    }
                    setValue(bindPropResult, newValue);
                //}

                resolve({ isSuccess: true, result: newValue });
            }
            else {
                setOptions(defaultOptions);

                var componentVal = bindPropResult ? getValues(bindPropResult) : "";

                if (triggerOnChange) onChange(componentVal);

                resolve({ isSuccess: true, result: componentVal });
            }
        });
    }

    function loadValue(newOptions, cptValue) {
        //console.debug(cptValue);
        if (!newOptions) newOptions = options;
        //var value = !commonFunc.isBlank(data.value) ? data.value : data.defaultValue;
        var value = !commonFunc.isBlank(cptValue) ? cptValue : data.defaultValue;
        //PATCH : value AKeyItem
        if (value?.startsWith && value.startsWith("{") && value.indexOf("tag") >= 0) {
            var keyItem = JSON.parse(value);
            value = keyItem.value;
        }
        var dOption = newOptions.filter((elem) => elem.value === value);
        var loadedValue = -1;
        if ((!commonFunc.isBlank(value) && (data.subType && (data.subType.startsWith("multiple") || data.subType.endsWith("create")))) || newOptions.length <= 0 || dOption.length > 0) {
            if (Array.isArray(value) && data.propNameJsType === "array" && data.format === "object") {
                //loadedValue = value.map(opt => { return { value: opt[data.argumentsObj?.loadIdTarget], label: opt[data.argumentsObj?.loadNameTarget] } });
                loadedValue = value;
            }
            else {
                loadedValue = value;
            }
        }
        else {
            /*if (!data.subType || !data.subType.startsWith("multiple")) {
                var selectedOption = newOptions.filter((elem) => elem.selected);
                if (selectedOption.length > 0) {
                    loadedValue = selectedOption[0].value;
                }
                else {
                    loadedValue = newOptions[0].value;
                }
            }
            else {
                loadedValue = "";
            }*/
            var selectedOption = newOptions.filter((elem) => elem.selected);
            if (data.subType?.startsWith("multiple")) {
                if (selectedOption.length) {
                    if (data.propNameJsType === "array" && data.format === "object") {
                        loadedValue = selectedOption.map(opt => opt.value);
                    }
                    else {
                        loadedValue = selectedOption.map(opt => opt.value).join(";");
                    }
                }
                else {
                    if (data.propNameJsType === "array") {
                        loadedValue = [];
                    }
                    else {
                        loadedValue = "";
                    }
                }
            }
            else {
                if (selectedOption.length) {
                    loadedValue = selectedOption[0].value;
                }
                else {
                    loadedValue = newOptions[0].value;
                }
            }
        }
        //console.debug(loadedValue);

        return loadedValue;
    }

    function renderInput(inputClass, inputStyle) {
        //Gestion select multiple
        if (data.subType && (data.subType.startsWith("multiple") || data.subType.endsWith("create"))) {
            var customOpt = [];
            options.forEach((option, index) => {
                if (!hideFilter) option.hiddenFilter = false;
                else if (option.srcData) {
                    var cKey = hideFilter.key;
                    var cOperator = hideFilter.operatorTest;
                    var cValue = hideFilter.value;
                    switch (cOperator) {
                        case "=": option.hiddenFilter = option.srcData[cKey] === cValue; break;
                        case "!=": option.hiddenFilter = option.srcData[cKey] !== cValue; break;
                        case "<": option.hiddenFilter = option.srcData[cKey] < cValue; break;
                        case "<=": option.hiddenFilter = option.srcData[cKey] <= cValue; break;
                        case ">": option.hiddenFilter = option.srcData[cKey] > cValue; break;
                        case ">=": option.hiddenFilter = option.srcData[cKey] >= cValue; break;
                        default:
                            break;
                    }
                }

                customOpt.push({ value: option.value, label: option.title });
            });

            var compArgs = {
                isMulti: data.subType.startsWith("multiple"),
                id: "select" + bindPropResult,
                className: `${inputClass} ${commonFunc.getValue(errors, bindPropResult) ? "react-select-invalid" : ""}`,
                isDisabled: disabled, /*innerRef={refElem} {...restElem}*/
                formatOptionLabel: (option, { context }) => {
                    return option.label;
                },
                onChange: (e) => {
                    if (Array.isArray(e)) {
                        var values
                        if (data.propNameJsType === "array") {
                            if (data.format === "object") {
                                values = e.map(v => data.functionManager.getSrcData(v.value));
                                if (!values) values = e;
                            }
                            else {
                                values = e.map(v => v.value);
                            }
                        }
                        else {
                            values = e.map(v => v.value).join(";");
                        }
                        onChange(values);
                        setValue(bindPropResult, values);
                    }
                    else {
                        onChange(e.value);
                        setValue(bindPropResult, e.value);
                    }
                },
                invalid: commonFunc.getValue(errors, bindPropResult) ? true : false,
                value: (() => {
                    var arrayOptions;
                    if (Array.isArray(currValue)) {
                        if (data.format === "object") {
                            //console.debug(currValue);
                            arrayOptions = currValue.map(opt => opt[data.argumentsObj?.loadIdTarget]);
                        }
                        else {
                            arrayOptions = currValue;
                        }
                    }
                    else if (currValue && currValue.split) {
                        arrayOptions = currValue.split(";");
                    }
                    //console.debug(currValue);
                    //console.debug(arrayOptions);
                    var option;
                    if (arrayOptions) {
                        option = arrayOptions.map((v, i) => {
                            if (!commonFunc.isBlank(v)) {
                                var value = parseInt(v) ? parseInt(v) : v;
                                var filterOption = options.filter(opt => opt.value === value);
                                var label;
                                if (filterOption.length > 0) {
                                    label = filterOption[0].title;
                                }
                                else if (Array.isArray(currValue) && data.format === "object") {
                                    var filterObj = currValue.filter(opt => opt[data.argumentsObj?.loadIdTarget] == v);
                                    label = filterObj?.length ? filterObj[0][data.argumentsObj?.loadNameTarget] : currValue[i][data.argumentsObj?.loadNameTarget];
                                }
                                else {
                                    label = v;
                                }
                                return { label: label, value: value };
                            }
                            else {
                                return "";
                            }
                        });
                    }
                    else {
                        var filterOption = options.filter(opt => opt.value === currValue);
                        var label;
                        if (filterOption.length > 0) {
                            label = filterOption[0].title;
                        }
                        if (label) {
                            option = { label: label, value: currValue };
                        }
                        else {
                            option = (currValue ? currValue : "");
                        }
                    }
                    return option;
                })(),
                options: customOpt,
                //styles: { control: inputStyle }
                styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
            };
            if (data.placeHolder) compArgs.placeholder = data.placeHolder;

            //Gestion création option
            if (data.subType.endsWith("create")) {
                return <CreatableSelect {...compArgs} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null} />;
            }
            else {
                return <Select {...compArgs} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null} />;
            }
        }
        else {
            return <Input id={"select" + bindPropResult} className={`${inputClass}`} style={inputStyle} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null} type="select" disabled={disabled} innerRef={refElem} {...restElem} invalid={commonFunc.getValue(errors, bindPropResult) ? true : false} value={currValue}>
                {(() => {
                    var optionsGrp = {};
                    options.forEach((option, index) => {
                        if (!hideFilter) option.hiddenFilter = false;
                        else if (option.srcData) {
                            var cKey = hideFilter.key;
                            var cOperator = hideFilter.operatorTest;
                            var cValue = hideFilter.value;
                            switch (cOperator) {
                                case "=": option.hiddenFilter = option.srcData[cKey] === cValue; break;
                                case "!=": option.hiddenFilter = option.srcData[cKey] !== cValue; break;
                                case "<": option.hiddenFilter = option.srcData[cKey] < cValue; break;
                                case "<=": option.hiddenFilter = option.srcData[cKey] <= cValue; break;
                                case ">": option.hiddenFilter = option.srcData[cKey] > cValue; break;
                                case ">=": option.hiddenFilter = option.srcData[cKey] >= cValue; break;
                                default:
                                    break;
                            }
                        }

                        if (option.objType) {
                            if (!optionsGrp[option.objType]) optionsGrp[option.objType] = [];
                            optionsGrp[option.objType].push(option);
                        }
                        else {
                            if (!optionsGrp["none"]) optionsGrp["none"] = [];
                            optionsGrp["none"].push(option);
                        }
                    });

                    var optionRendering = (option, index) => {
                        return <option className={`${(option.hidden || option.hiddenFilter) ? "d-none" : ""}`} key={index} selected={option.selected} value={option.value}>
                            {option.customDesign && option.customDesign.design && option.customDesign.design.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                            {option.title}
                        </option>
                    };

                    return Object.keys(optionsGrp).map((key, indexGrp) => {
                        var values = optionsGrp[key];
                        if (key === "none") {
                            return values.map(optionRendering);
                        }
                        else {
                            return <optgroup key={indexGrp} label={key}>
                                {values.map(optionRendering)}
                            </optgroup>
                        }
                    });
                })()}
            </Input>;
        }
    }

    function renderTitle(positions, titleWidthClass, titleWidthStyle) {
        var design = data.customDesign ? data.customDesign.designTitle : null;
        if (!design) design = {}
        var position = design.position;
        if (!position) position = "left";

        var titleModel = <Label className={`${titleWidthClass} ${(position === "left" || position === "right") ? "m-0" : ""} ${(!commonFunc.isBlank(data.title) && data.required) ? "mandatory" : ""}`} style={titleWidthStyle} data-backimage={titleWidthStyle.hasImage || null} data-imageopacity={titleWidthStyle.alpha || null} for={"input" + bindPropResult}>{data.title}</Label>;

        if (!commonFunc.isBlank(data.title) && positions.indexOf(position) >= 0) return titleModel;
        else return "";
    }

    var frameClass = "d-inline-block mb-3";
    var frameStyle = {};
    var containerClass = "";
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var formClass = "";

    var widthClass = "";
    var widthStyle = {};
    var inputClass = "";
    var inputStyle = {};
    var titleWidthClass = "px-0 ";
    var titleWidthStyle = { color: "rgb(37, 36, 34)" };

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_dropdown");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            frameClass += modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
        }

        Object.assign(frameStyle, modelFctManager.setCustomBackground(design, data));
        //Object.assign(frameStyle, modelFctManager.managePadding(design, frameClass));
        Object.assign(frameStyle, modelFctManager.manageMargin(design, frameClass));

        if (design.size || design.width) frameStyle.width = (design.size ? (design.size + "px") : design.width);
        if (design.height) frameStyle.height = design.height;

        if (design.margin) {
            frameStyle.margin = design.margin;
            frameClass = frameClass.replace("mb-3", "");
        }
    }
    var designInput = data.customDesign?.designInput;
    designInput = modelFctManager.prepareMergedDesign(data, designInput, "default_dropdownInput", true);
    if (designInput) {
        if (designInput.boxSize) {
            //widthClass += " w-" + parseInt(parseFloat(designInput.boxSize) * 100);
            widthClass += modelFctManager.convertWidthToGrid(parseFloat(designInput.boxSize) * 100);
        }

        Object.assign(inputStyle, modelFctManager.setCustomBackground(designInput, data));
        //Object.assign(inputStyle, modelFctManager.managePadding(designInput, inputClass));
        Object.assign(inputStyle, modelFctManager.manageMargin(designInput, inputClass));


        //TODO : icon

        if (designInput.size || designInput.width) inputStyle.width = (designInput.size ? (designInput.size + "px") : designInput.width);
        if (designInput.height) inputStyle.height = designInput.height;

        /*if (designInput.fontColor) inputStyle.color = modelFctManager.getRgbaFromHex(designInput.fontColor);
        if (designInput.fontSize) inputStyle.fontSize = designInput.fontSize;
        if (designInput.fontStyle) {
            if (designInput.fontStyle.indexOf("bold") >= 0) inputStyle.fontWeight = "bold";
            if (designInput.fontStyle.indexOf("italic") >= 0) inputStyle.fontStyle = "italic";
        }*/

        if (designInput.alignment) {//TODO : TO CHECK
            var split = designInput.alignment.split("|");
            split.forEach((part) => {
                inputClass += " text-" + part.replace("left", "start").replace("right", "end");
                inputClass = inputClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }
    }
    var designTitle = data.customDesign?.designTitle;
    designTitle = modelFctManager.prepareMergedDesign(data, designTitle, "default_dropdownTitle", true);
    if (designTitle) {
        Object.assign(titleWidthStyle, modelFctManager.setCustomBackground(designTitle, data));
        //Object.assign(titleWidthStyle, modelFctManager.managePadding(designTitle, titleWidthClass));
        Object.assign(titleWidthStyle, modelFctManager.manageMargin(designTitle, titleWidthClass));

        if (designTitle.size || designTitle.width) titleWidthStyle.width = (designTitle.size ? (designTitle.size + "px") : designTitle.width);
        if (designTitle.height) titleWidthStyle.height = designTitle.height;

        if (designTitle.fontColor) titleWidthStyle.color = modelFctManager.getRgbaFromHex(designTitle.fontColor);
        if (designTitle.fontSize) titleWidthStyle.fontSize = designTitle.fontSize;
        if (designTitle.fontStyle) {
            if (designTitle.fontStyle.indexOf("bold") >= 0) titleWidthStyle.fontWeight = "bold";
            if (designTitle.fontStyle.indexOf("italic") >= 0) titleWidthStyle.fontStyle = "italic";
        }

        if (designTitle.alignment) {
            var splitTitle = designTitle.alignment.split("|");
            splitTitle.forEach((part) => {
                titleWidthClass += " text-" + part.replace("left", "start").replace("right", "end");
                titleWidthClass = titleWidthClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }
        if (designTitle.position === "floating") {
            formClass += " form-floating min-input";
        }
        if (designTitle.boxSize) {
            //titleWidthClass += " w-" + parseInt(parseFloat(designTitle.boxSize) * 100);
            titleWidthClass += modelFctManager.convertWidthToGrid(parseFloat(designTitle.boxSize) * 100);
            titleWidthClass = titleWidthClass.replace("px-0", "ps-3 px-md-0").replace("text-end", "text-md-end");
        }
    }

    if (!commonFunc.isBlank(widthClass) || titleWidthClass !== "px-0 ") containerClass += " row m-0 row-cols-lg-auto2 align-items-center";

    if (!designTitle) {
        widthClass += " w-100";
    }

    var baseForm = <div className={`${containerClass} ${formClass}`}>
        {renderTitle(["top", "left"], titleWidthClass, titleWidthStyle)}
        <div className={`${widthClass}`} style={widthStyle}>
            {renderInput(inputClass, inputStyle)}
            <FormFeedback className={`text-start ${commonFunc.getValue(errors, bindPropResult) ? "d-block" : ""}`}>{commonFunc.getValue(errors, bindPropResult) ? commonFunc.getValue(errors, bindPropResult).message : ""}</FormFeedback>
        </div>
        {renderTitle(["bottom", "right", "floating"], titleWidthClass, titleWidthStyle)}
    </div>;

    return <Col data-name="SpinnerFrag" data-element={data.objType} xs="auto" className={` ${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null}>{baseForm}</Col>;//align-self-center
}